<a [routerLink]="['..']" class="adap-link link-return">
  <mat-icon svgIcon="cvx-left"></mat-icon>
  global settings
</a>

<div class="group-container header">
  <div class="header-title">business units</div>
  <button
    class="adap-btn-filled add-business-unit-button"
    type="button"
    (click)="addBusinessUnit()"
  >
    add business unit <mat-icon svgIcon="cvx-plus-circle"></mat-icon>
  </button>

  <app-business-units-table
    (editBusinessUnit)="editBusinessUnit($event)"
    (deleteBusinessUnit)="deleteBusinessUnit($event)"
  ></app-business-units-table>
</div>
